import { buildModelManager } from "../builder.js";
const DefaultMicuMedicationInstanceSelection = {
  __typename: true,
  id: true,
  caseId: true,
  createdAt: true,
  currentParams: true,
  drugName: true,
  templateId: true,
  updatedAt: true
};
const modelApiIdentifier = "micuMedicationInstance";
const pluralModelApiIdentifier = "micuMedicationInstances";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuMedicationInstanceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuMedicationInstanceSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationInstanceSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationInstanceSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationInstanceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationInstanceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuMedicationInstanceSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "micuMedicationInstanceGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MicuMedicationInstanceManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMicuMedicationInstanceSelection,
  operations
);
export {
  DefaultMicuMedicationInstanceSelection,
  MicuMedicationInstanceManager
};
//# sourceMappingURL=MicuMedicationInstance.js.map
